/**
 * TODO: we can remove this module and its usages when migration to v2 is complete
 */
import { uniqueContext } from "./uniqueContext"

const uiclContext = uniqueContext<{ v2: boolean }>("uiclContext")

export const setUiclContext = uiclContext.setContext
export const getUiclContext = uiclContext.getContext
